import React from "react";
import GestionAlojamientoLogiflex from "./GestionAlojamientoLogiflex";
import { GESTION_ALOJAMIENTO_MODOS } from "./gestionAlojamientoConfig";

const GestionCheckIn = () => (
  <GestionAlojamientoLogiflex config={GESTION_ALOJAMIENTO_MODOS.checkin} />
);

export default GestionCheckIn;
